export function getSubdomainFromHostname(hostname: string): string[] {
  return hostname.split(".").reverse().slice(2).reverse()
}
